import type { UpdateSubsidiaryRequestPayload, UpdateSubsidiaryResponse } from '@vy/api-definition';
import { UpdateSubsidiaryResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useUpdateSubsidiary(
  subsidiaryId: string,
  options?: UseMutationOptions<UpdateSubsidiaryResponse, unknown, UpdateSubsidiaryRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ subsidiary }) => {
      const api = getPrivateApi();

      const updateSubsidiaryResponse = await api.updateSubsidiary({
        updateSubsidiaryRequest: { subsidiary },
        subsidiaryId,
      });

      return UpdateSubsidiaryResponseSchema.parse(updateSubsidiaryResponse);
    },
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.subsidiaries() });
    },
  });
}
